import { dashboardRoutes } from './config'
import { IGlobalState } from './reducers'

export const titles = {
  dashboard: 'Dashboard',
  editGift: 'Edit gift',
  giftRequests: 'Gift requests',
  gifts: 'Gifts',
  list: 'List',
  newGift: 'New gift',
  requests: 'Requests',
  settings: 'Settings',
  team: 'Team',
  title1: 'Title1',
  transfers: 'Transfers',
  users: 'Users',
  statisticals: 'Statisticals',
  topUsers: 'Top Users',
  topUsersDetail : 'Top Users Detail',
  kudosStatistic: 'Kudos Statistic',
  timeTracking: 'Time Tracking',
}

export const pageTitleMapping = {
  [dashboardRoutes.dashboardPage]: (state?: IGlobalState) => titles.dashboard,
  [dashboardRoutes.newGiftPage]: (state?: IGlobalState) => titles.newGift,
  [dashboardRoutes.editGiftPage]: (state?: IGlobalState) => titles.editGift,
  [dashboardRoutes.giftRequestsPage]:(state?: IGlobalState) => titles.giftRequests,
  [dashboardRoutes.giftsManagementPage]: (state?: IGlobalState) => titles.gifts,
  [dashboardRoutes.settingPage]: (state?: IGlobalState) => titles.settings,
  [dashboardRoutes.transfersPage]: (state?: IGlobalState) => titles.transfers,
  [dashboardRoutes.teamManagementPage]: (state?: IGlobalState) => titles.team,
  [dashboardRoutes.statisticalsPage ]: (state?: IGlobalState) => titles.statisticals,
  [dashboardRoutes.usersTopPage]: (state?: IGlobalState) => titles.topUsers,
  [dashboardRoutes.usersTopDetailPage]: (state?: IGlobalState) => titles.topUsersDetail,
  [dashboardRoutes.kudosStatisticPage]: (state?: IGlobalState) => titles.kudosStatistic,
  [dashboardRoutes.timeTrackingPage]: (state?: IGlobalState) => titles.timeTracking,
}

export const settingsCardsTitles = {
  answerChannels: 'Kudos bot answer channel:',
  giftRequestsReceiver: 'Receiver of gift requests:',
  monthlyKudosAmount: 'Amount of Kudos in month:'
}
